import React from 'react';
import { WebForm } from '@platform/formio/WebForm';
import { FormApi } from '../api/FormApi';
import Form from './Form';
import { FormModel } from '../models/FormModel';

export type FormViewProps = {
    locale: string;
    form: FormModel;
    onFormReady?: (instance: FormApi) => void;
    onFormChange?: (instance: WebForm) => void;
    className?: string;
    multiLang?: boolean;
};

const FormView = (props: FormViewProps): JSX.Element => {
    const { form, onFormReady, onFormChange, locale, className, multiLang } = props;
    return (
        <Form
            form={form}
            onFormReady={onFormReady}
            readOnly={true}
            onFormChange={onFormChange}
            locale={locale}
            lang={locale}
            className={className}
            multiLang={multiLang}
        />
    );
};

export default FormView;
